import React, { useEffect, useState, useCallback, useMemo } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Form,
} from "reactstrap";
import "./index.css";
import { useDispatch, useSelector } from "react-redux";
import TextField from "@mui/material/TextField";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { StaticDatePicker } from "@mui/x-date-pickers/StaticDatePicker";
import Badge from "@mui/material/Badge";
import { PickersDay } from "@mui/x-date-pickers/PickersDay";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import SvgImage from "../../../../Icons/Icons";
import {
  editDriverAttendence,
  getDriverAttendence,
} from "../../../../../services/Store/Actions/fastagAction";
import moment from "moment";
import NightsStayRoundedIcon from "@mui/icons-material/NightsStayRounded";
import ManageDriverAddBalance from "../../../../Modals/ManageDriverAddBalance";
import { getSalaryWalletSummary } from "../../../../../services/Store/Actions/driverslistActions";
import { useNavigate } from "react-router-dom";
function Attendence(props) {
  const [presentDay, setPresentDay] = useState(0);
  const [reserveDay, setReserveDay] = useState(0);
  const {
    toggle,
    modal,
    setModal,
    regNo,
    title,
    fleetId,
    userId,
    phone,
    name,
  } = props;
  const [value, setValue] = useState(new Date());
  const { customRequest } = useSelector((state) => state.fastag);
  console.log("customRequestcustomRequest", value);
  const [driverData, setDriverData] = useState({});
  const navigate = useNavigate();
  const { driverAttedenceData } = useSelector((state) => state?.fastag);
  const dispatch = useDispatch();
  const { salaryWalletSummary } = useSelector((state) => state?.driverlist);
  const {allDriverListAdvance } =
    useSelector((state) => state?.driverlist);
  const driver = allDriverListAdvance?.find(elem => elem?.userId == userId)

  const handleClose = () => {
    console.log("handleClosesds");
    setModal(false);
  };

  const [highlightedDays, setHighlightedDays] = useState([]);
  const [presentSalary, setPresentSalary] = useState();
  const [reserveSalary, setReserveSalary] = useState();
  const [salary, setSalary] = useState(700);
  const [open, setOpen] = useState(false);

  const toggleModal = () => {
    setOpen(!open);
  };

  useEffect(() => {
    dispatch(
      getDriverAttendence(
        {
          userId: `${driver?.userId}`,
          date: `${moment(value).format("YYYY-MM-DD")}`,
        },
        (res) => {
          console.log("customRequestdhbjdsghjkljdsghvb", res?.data?.rows);
          setHighlightedDays(res?.data?.rows);
          res?.data?.rows.filter((x) => {
            console.log("svbnsvbdnm", x);
            if (x.date == moment(new Date()).format("DD")) {
              setDriverData(x.data);
            }
          });
        }
      )
    );
    dispatch(
      getSalaryWalletSummary(phone, {
        offset: 0,
        sortAs: "",
        sortBy: "",
        limit: 1,
      })
    );
    setDriverData({});
    setHighlightedDays([]);
    setPresentSalary(0);
    setReserveSalary(0);
  }, [modal]);

  useEffect(() => {
    let temp1 = highlightedDays.filter(function (x) {
      return x.attendence == "1";
    });
    let temp2 = highlightedDays.filter(function (x) {
      return x.attendence == "2";
    });
    setPresentDay(temp1.length);
    setReserveDay(temp2.length);
    console.log("highlightedDayshighlightedDays", temp1, temp2);
  }, [highlightedDays]);

  console.log("customRequestdhbjdsghjkljdsghvvgbnjhbghn", salaryWalletSummary);

  return (
    <div>
      <Modal
        isOpen={modal}
        onHide={handleClose}
        className=" modal-dialog-centered model-width"
        toggle={toggle}
        aria-labelledby="myModalLabel2"
      >
        <div>
          <div className="closeBtnWithBackground" onClick={handleClose}>
            <SvgImage
              classname="close-btn-text"
              style={{ width: "10%", height: "10%" }}
              name="crossBtnWIthBackground"
              width="20%"
              height="20%"
            />
          </div>

          <div
            style={{ marginTop: " 10px", marginBottom: "10px" }}
            className="row"
            //   className="PGCollectionBox"
          >
            <div className="showroomText col-12">Attendence</div>
          </div>
        </div>
        <div
          style={{
            display: "flex",
            flex: 1,
            flexDirection: "row",
          }}
        >
          <div style={{ width: "50%" }}>
            <LocalizationProvider dateAdapter={AdapterDateFns}>
              <StaticDatePicker
                // mask='____/__/__'
                variant="static"
                orientation="landscape"
                value={value}
                disableFuture
                onChange={(newValue) => {
                  console.log(
                    "sbhjsbsbs",
                    newValue
                    // moment(newValue).format("DD-MM-YYYY") ==
                    //   moment(date).format("DD-MM-YYYY")
                  );
                  setValue(newValue);
                  for (var i = 0; i <= driverAttedenceData?.rows?.length; i++) {
                    console.log(
                      "hasValueLessThanTen",
                      driverAttedenceData?.rows[i]
                    );
                    if (
                      moment(newValue).format("DD-MM-YYYY") ==
                      moment(driverAttedenceData?.rows[i].createdAt).format(
                        "DD-MM-YYYY"
                      )
                    ) {
                      setDriverData(driverAttedenceData?.rows[i]);
                      break;
                    } else {
                      setDriverData({});
                    }
                  }
                }}
                onMonthChange={(val) => {
                  console.log("monthchange", val);
                  dispatch(
                    getDriverAttendence(
                      {
                        userId: `${driver?.userId}`,
                        date: `${moment(val).format("YYYY-MM-DD")}`,
                      },
                      (res) => {
                        console.log(
                          "customRequestdhbjdsghjkljdsghvb",
                          res?.data?.rows
                        );
                        setHighlightedDays(res?.data?.rows);
                      }
                    )
                  );
                }}
                renderInput={(params) => {
                  <TextField {...params} />;
                }}
                renderDay={(day, _value, DayComponentProps) => {
                  const isSelected =
                    !DayComponentProps.outsideCurrentMonth &&
                    highlightedDays.filter((x) => {
                      console.log(
                        "ghkjhgbjhbghj",
                        x,
                        moment(day).format("YYYY-MM-DD"),
                        moment(x.createdAt).format("YYYY-MM-DD")
                      );
                      if (
                        moment(x.createdAt).format("YYYY-MM-DD") ==
                          moment(day).format("YYYY-MM-DD") &&
                        x.attendence == "1"
                      ) {
                        // let temp = presentDay;
                        // temp = temp + 1;
                        // setPresentDay(temp)
                        return true;
                      }
                    }).length > 0;
                  console.log("isSelectedisSelected", isSelected);

                  const reserve =
                    !DayComponentProps.outsideCurrentMonth &&
                    highlightedDays.filter((x) => {
                      console.log(
                        "ghkjhgbjhbghj",
                        x,
                        moment(day).format("YYYY-MM-DD"),
                        moment(x.createdAt).format("YYYY-MM-DD")
                      );
                      if (
                        moment(x.createdAt).format("YYYY-MM-DD") ==
                          moment(day).format("YYYY-MM-DD") &&
                        x.attendence == "2"
                      ) {
                        // let temp = reserveDay;
                        // temp = temp + 1;
                        // setReserveDay(temp)
                        return true;
                      }
                    }).length > 0;
                  console.log("reservereserve", reserve);

                  return (
                    <Badge
                      key={day.toString()}
                      overlap="circular"
                      badgeContent={
                        isSelected ? (
                          <CheckIcon color="red" />
                        ) : reserve ? (
                          <NightsStayRoundedIcon
                            color="red"
                            style={{
                              color: "red",
                            }}
                          />
                        ) : (
                          ""
                        )
                      }
                    >
                      <PickersDay {...DayComponentProps} />
                    </Badge>
                  );
                }}
              />
            </LocalizationProvider>
          </div>
          {
            <div className="row" style={{ width: "50%" }}>
              {/* <strong
              className="col-5"
              style={{
                display: "flex",
                flexDirection: "row",
                flex: 1,
                justifyContent: "center",
                fontSize: "20px",
                color: "#141823",
              }}
            >
              Additional Data
            </strong> */}
              <div
                style={
                  {
                    // marginTop: "-100px",
                  }
                }
              >
                {driverData?.attendence && (
                  <div>
                    <strong
                      style={{
                        fontSize: "15px",
                        color: "black",
                      }}
                    >
                      Logged At:{" "}
                    </strong>
                    <a style={{}}>
                      {`  ${
                        driverData?.createdAt ? driverData?.createdAt : ""
                      }`}
                    </a>
                    <br />
                    <strong
                      style={{
                        fontSize: "15px",
                        color: "black",
                      }}
                    >
                      Logged Out:{" "}
                    </strong>
                    <a style={{}}>
                      {`  ${driverData?.logout ? driverData?.logout : ""}`}
                    </a>
                    <br />
                    <strong
                      style={{
                        fontSize: "15px",
                        color: "black",
                      }}
                    >
                      Start Km:{" "}
                    </strong>
                    <a style={{}}>
                      {`  ${
                        driverData?.initialValue ? driverData?.initialValue : ""
                      }`}
                    </a>
                    <br />
                    <strong
                      style={{
                        fontSize: "15px",
                        color: "black",
                      }}
                    >
                      End Km:{" "}
                    </strong>
                    <a style={{}}>
                      {`  ${
                        driverData?.finalValue ? driverData?.finalValue : ""
                      }`}
                    </a>
                    <br />
                    <strong
                      style={{
                        fontSize: "15px",
                        color: "black",
                      }}
                    >
                      VRN:{" "}
                    </strong>
                    <a style={{}}>{`  ${
                      driverData?.vrn ? driverData?.vrn : ""
                    }`}</a>
                    <br />
                  </div>
                )}
                <div>
                  <strong
                    style={{
                      fontSize: "15px",
                      color: "black",
                    }}
                    onClick={() => {
                      console.log("presentSalary", presentSalary);
                    }}
                  >
                    Present Salary:{" "}
                  </strong>
                  <a>
                    {/* {`  ${driverData?.wage?driverData?.wage:''}`} */}
                    <input
                      type="number"
                      name="presentSalary"
                      id="presentSalary"
                      placeholder={"400"}
                      aria-label="Default select example"
                      onChange={(e) => {
                        console.log("changingnnn", e.target.value);
                        setPresentSalary(e.target.value);
                      }}
                      onClick={(e) => {
                        console.log("clicking", e);
                      }}
                      value={presentSalary}
                      onBlur={() => {}}
                      onKeyUp={(e) => {}}
                      autoComplete={"off"}
                      style={{
                        width: "65px",
                      }}
                    ></input>
                  </a>

                  <strong
                    style={{
                      fontSize: "15px",
                      color: "black",
                      marginLeft: "10px",
                    }}
                    onClick={() => {
                      console.log("presentSalary", presentSalary);
                    }}
                  >
                    Reserve Salary:{" "}
                  </strong>
                  <a>
                    {/* {`  ${driverData?.wage?driverData?.wage:''}`} */}
                    <input
                      type="number"
                      name="reserveSalary"
                      id="reserveSalary"
                      placeholder={"200"}
                      aria-label="Default select example"
                      onChange={(e) => {
                        console.log("changingnnn", e.target.value);
                        setReserveSalary(e.target.value);
                      }}
                      onClick={(e) => {
                        console.log("clicking", e);
                      }}
                      value={reserveSalary}
                      onBlur={() => {}}
                      onKeyUp={(e) => {}}
                      autoComplete={"off"}
                      style={{
                        width: "65px",
                      }}
                    ></input>
                  </a>
                  <br />

                  <button
                    className={"cardButton"}
                    style={{
                      color: "#FFFFFF",
                      backgroundColor: "#ED752E",
                      width: "381px",
                      marginTop: "10px",
                    }}
                    onClick={() => {
                      toggleModal();
                    }}
                  >
                    {console.log("nssnsnsnnsnsnsns",reserveSalary , reserveDay , presentSalary , presentDay)}
                    {`Pay Salary:  ₹ ${
                      reserveSalary * reserveDay + presentSalary * presentDay
                        ? reserveSalary * reserveDay +
                          presentSalary * presentDay
                        : "0"
                    }`}
                  </button>
                  <div className="col-12 flexStyling homeCard-Transaction" onClick={()=>{navigate(`/salary/${driver?.phone}`);}}>
              <p className="clickArrow heading3 semiBold greenFont" style={{fontSize : "15px",marginLeft: "130px",}}>All Transactions/Salary Accounts</p>
              <SvgImage
                name="ForwardArrow"
                height="32"
                width="32"
                className=""
              />
            </div>
                  {/* <br /> */}
                { salaryWalletSummary[0]?.createdAt && salaryWalletSummary[0]?.amount && <div>
                    <strong
                      style={{
                        fontSize: "15px",
                        color: "black",
                        marginLeft: "10px",
                      }}
                      onClick={() => {
                        console.log("presentSalary", presentSalary);
                      }}
                    >
                      Last Salary Date:{" "}
                    </strong>
                    <a>
                      {moment(salaryWalletSummary[0].createdAt).format(
                        "YYYY-MM-DD"
                      )}
                    </a>

                    <strong
                      style={{
                        fontSize: "15px",
                        color: "black",
                        marginLeft: "10px",
                      }}
                      onClick={() => {
                        console.log("presentSalary", presentSalary);
                      }}
                    >
                      Last Salary amount:{" "}
                    </strong>
                    <a>{salaryWalletSummary[0]?.amount}</a>
                    <div className="row">
            
            
            {/* {
              <CardWalletAllTransactionWallet
                history={history}
                Title={Title}
                open={open}
                toggleModal={toggleModal}
                handleClose={handleClose}
              />
            } */}
          </div>
                  </div>
                  }

                  <div
                    style={{
                      marginTop: "5px",
                    }}
                  >
                    <button
                      className={"cardButton"}
                      style={{ color: "#FFFFFF" }}
                      onClick={() => {
                        console.log("presentPayload",driver,driverData,{
                          VehicleDataId: driverData?.VehicleDataId,
                          attendence:'1'
                        })
                        dispatch(
                          editDriverAttendence(
                            {
                              VehicleDataId: driverData?.VehicleDataId,
                              attendence:'1',
                              fleetId:driver?.fleetId,
                              driverName: driver?.fullName,
                              driverUserId:driver?.userId,
                              date:value
                            },
                            (res) => {
                              console.log("jsjdjddj", res);
                              dispatch(
                                getDriverAttendence(
                                  {
                                    userId: `${driver?.userId}`,
                                    date: `${moment(value).format(
                                      "YYYY-MM-DD"
                                    )}`,
                                  },
                                  (res) => {
                                    console.log(
                                      "customRequestdhbjdsghjkljdsghvb",
                                      res?.data?.rows
                                    );
                                    setHighlightedDays(res?.data?.rows);
                                  }
                                )
                              );
                            }
                          )
                        );
                      }}
                    >
                      Mark Present
                    </button>
                    <button
                      className={"cardButton"}
                      style={{ color: "#FFFFFF" }}
                      onClick={() => {
                        console.log(
                          "sjbjsbsjbs",
                          moment(value).format("YY-MM-DD"),
                          driverData,
                          {
                            VehicleDataId: driverData?.VehicleDataId,
                            attendence:'2',
                            fleetId:driver?.fleetId,
                            driverName: driver?.fullName,
                            driverUserId:driver?.userId,
                            date:value
                          }
                        );
                        dispatch(
                          editDriverAttendence(
                            {
                              VehicleDataId: driverData?.VehicleDataId,
                              attendence:'2',
                              fleetId:driver?.fleetId,
                              driverName: driver?.fullName,
                              driverUserId:driver?.userId,
                              date:value
                            },
                            (res) => {
                              console.log("jsjdjddj", res);
                              dispatch(
                                getDriverAttendence(
                                  {
                                    userId: `${driver?.userId}`,
                                    date: `${moment(value).format(
                                      "YYYY-MM-DD"
                                    )}`,
                                  },
                                  (res) => {
                                    console.log(
                                      "customRequestdhbjdsghjkljdsghvb",
                                      res?.data?.rows
                                    );
                                    setHighlightedDays(res?.data?.rows);
                                  }
                                )
                              );
                            }
                          )
                        );
                      }}
                    >
                      Mark Reserve
                    </button>
                    {
                      <button
                        className={"cardButton"}
                        style={{ color: "#FFFFFF" }}
                        onClick={() => {
                          dispatch(
                            editDriverAttendence(
                              {
                                VehicleDataId: driverData?.VehicleDataId,
                                attendence:'0',
                                fleetId:driver?.fleetId,
                                driverName: driver?.fullName,
                                driverUserId:driver?.userId,
                                date:value
                              },
                              (res) => {
                                console.log("jsjdjddj", res);
                                dispatch(
                                  getDriverAttendence(
                                    {
                                      userId: `${driver?.userId}`,
                                      date: `${moment(value).format(
                                        "YYYY-MM-DD"
                                      )}`,
                                    },
                                    (res) => {
                                      console.log(
                                        "customRequestdhbjdsghjkljdsghvb",
                                        res?.data?.rows
                                      );
                                      setHighlightedDays(res?.data?.rows);
                                    }
                                  )
                                );
                              }
                            )
                          );
                        }}
                      >
                        Mark Absent
                      </button>
                    }
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      </Modal>
      <ManageDriverAddBalance
        open={open}
        toggleModal={toggleModal}
        handleClose={handleClose}
        name="Add Balance"
        userId={driver?.userId}
        cardType={1}
        offset={0}
        search={0}
        apiCall={true}
        amount={
          reserveSalary * reserveDay + presentSalary * presentDay
            ? reserveSalary * reserveDay + presentSalary * presentDay
            : "0"
        }
        phone={phone}
        custom={1}
        workingDays={reserveDay + presentDay}
      />
    </div>
  );
}

export default Attendence;
